<template>
  <div class="doughnut-wrapper">
    <img :src="faceIcon" alt="face-icon" class="face-icon" />
    <doughnut
      class="doughnut"
      :chartdata="chartdata"
      :options="options"
      :plugins="plugins"
      :width="120"
      :height="120"
    />
  </div>
</template>

<script>
import VueTypes from "vue-types";
import Doughnut from "./DoughnutChart";

import Normal from "../../../static/face_normal.png";
import Caution from "../../../static/face_caution.png";
import Risk from "../../../static/face_risk.png";
import HighRisk from "../../../static/face_highrisk.png";

import ChartDataLabels from "chartjs-plugin-datalabels";

export default {
  components: {
    Doughnut
  },
  data() {
    return {
      Normal: Normal,
      Caution: Caution,
      Risk: Risk,
      HighRisk: HighRisk,
      plugins: [ChartDataLabels]
    };
  },
  props: {
    riskRate: VueTypes.isRequired,
    riskIndex: VueTypes.number.isRequired
  },
  computed: {
    chartdata() {
      return {
        datasets: [
          {
            data: [40, this.a, this.b, this.c, this.d],
            backgroundColor: [
              "#ffffff",
              "#96BF92",
              "#ECD460",
              "#DFAF81",
              "#CF7D8E"
            ],
            borderColor: "#F1F1F1",
            borderWidth: 0
          }
        ]
      };
    },
    a() {
      return Math.floor(this.riskRate[0]);
    },
    b() {
      return Math.floor(this.riskRate[1] - this.a);
    },
    c() {
      return Math.floor(this.riskRate[2] - (this.a + this.b));
    },
    d() {
      return Math.floor(100 - (this.a + this.b + this.c));
    },
    faceIcon() {
      if (this.riskIndex === 0) {
        return this.Normal;
      } else if (this.riskIndex === 1) {
        return this.Caution;
      } else if (this.riskIndex === 2) {
        return this.Risk;
      } else {
        return this.HighRisk;
      }
    },
    options() {
      let _this = this;
      return {
        responsive: true,
        maintainAspectRatio: false,
        rotation: 0.2 * Math.PI,
        cutoutPercentage: 85,
        legend: {
          display: false
        },
        tooltips: {
          enabled: false
        },
        hover: {
          mode: null
        },
        plugins: {
          datalabels: {
            color: "#419AE1",
            anchor: "center",
            borderColor: "#ffffff",
            borderRadius: 25,
            borderWidth: 1,
            backgroundColor: "#419AE1",
            display(context) {
              return context.dataIndex === _this.riskIndex + 1;
            }
          }
        }
      };
    }
  }
};
</script>

<style scoped>
.doughnut-wrapper {
  display: grid;
}
.doughnut-wrapper > img {
  z-index: -1;
  grid-column: 2/3;
  grid-row: 2/3;
}
.doughnut-wrapper > .doughnut {
  grid-column: 1/4;
  grid-row: 1/4;
}
/*画面サイズ480pxから*/
@media screen and (max-width:767px){
  .doughnut {
    height: 140px;
  }
  .face-icon {
    width: 80px;
  }
}
@media screen and (min-width: 768px) and (max-width: 1023px) {
  .doughnut {
    height: 150px;
  }
  .face-icon {
    width: 85px;
  }
}
@media screen and (min-width: 1024px) and (max-width: 2559px) {
  .doughnut {
    height: 160px;
  }
  .face-icon {
    width: 90px;
  }
}
@media screen and (min-width: 2560px) {
  .doughnut {
    height: 180px;
  }
  .face-icon {
    width: 110px;
  }
  /* 画面のサイズに合わせて顔のアイコンサイズを調整 */
}
</style>
